<template>
    <div>
        <div class="button" @click="showList = !showList" v-if="!showList" key="button">
            <div>设备列表</div>
            <img src="../../assets/img/箭头右.png" alt="">
        </div>
        <transition name="list">
            <div class="list" v-if="showList" key="list">
                <div class="title" @click="showList = false">
                    <div>设备列表</div>
                    <img src="../../assets/img/箭头蓝.png" alt="">
                </div>
                <div class="content" id="deviceDetailContent">
                    <el-tree :data="list" :props="defaultProps" default-expand-all highlight-current
                        :expand-on-click-node='true' @node-click="handleNodeClick" node-key="id" ref="deviceTree" :current-node-key="currentNodeKey">
                        <!-- 插入元素 -->
                        <!-- <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span>{{ node.label}}</span>
                            <img v-if="node.childNodes.length < 1" :src="require('@/assets/img/定位.png')"
                                @click.stop="handleClickPosition(node,data)" />
                        </span> -->
                    </el-tree>
                    <!-- <el-tree :data="treeList" :highlight-current="highLight" ref="treeList"
                        :render-content="renderContent" :expand-on-click-node='false' :default-expanded-keys='[0]'
                        node-key='id' :props="defaultProps" @node-click="handleNodeClick" lazy></el-tree> -->
                </div>
            </div>
        </transition>

        <div class="detail" v-show="showDetail" v-drag>
            <div class="head">
                <img :src="currentDevice.deviceImg" class="pic" alt="">
                <div class="data">
                    <div style="font-size:18rem;color:rgba(13, 148, 255, 1)">{{currentDevice.deviceName || '设备名称'}}
                    </div>
                    <div>类型 : {{currentDevice.deviceClassName || ''}}</div>
                    <div>型号 : {{currentDevice.deviceModelName || ''}}</div>
                    <!-- <div>站点 : {{currentDevice.deviceType || ''}}</div> -->
                </div>
                <img class="close" src="../../assets/img/关闭.png" alt="" @click="showDetail = false">
            </div>
            <div class="body">
                <ExpandTable v-for="(value,key,index) in currentDevice.deviceDetails" :key="index" :name="key"
                    :details="value" :modelId="currentDevice.modelId" />
            </div>
        </div>
    </div>
</template>

<script>
    import ExpandTable from '@/components/ExpandTable'
    import {
        GetDeviceTypeAndInfo,
    } from "@/components/Request";

    export default {
        components: {
            ExpandTable
        },
        name: "DeviceDetail",
        props: ["areaId"],
        data() {
            return {
                // 设备列表
                showList: false,
                // 当前区域所有设备modelId
                allDeviceModelID: [],
                // 设备详情
                showDetail: false,
                // 树形设备列表
                list: [],
                // 当前设备信息
                currentDevice: {
                    modelId: '',
                    deviceImg: '',
                    deviceName: '',
                    deviceType: '',
                    deviceDetails: {},
                },
                currentNodeKey: 0,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            };
        },
        watch:{
            currentNodeKey(n,o){
                // console.log(n)
            }
        },
        mounted() {
            GetDeviceTypeAndInfo({
                areaId: this.areaId
            }).then(({
                data
            }) => {
                // console.log(data.data)
                // console.log(data.data.infos.deviceCategories)
                let deviceList = data.data.infos.deviceCategories.find(item => item.deviceCategoryId == 1)
                    .deviceClasses
                // console.log(deviceList)
                let allDeviceModelIDArr = []
                let id = 0
                deviceList.forEach((item1, index1) => {
                    // console.log(item1, index1)
                    this.list[index1] = {
                        id: ++id,
                        label: item1.deviceClassName,
                        children: [],
                    }
                    item1.devices.forEach((item2, index2) => {
                        // console.log(item2, index2)
                        this.list[index1].children[index2] = {
                            id: ++id,
                            label: item2.deviceName,
                            deviceInfo: item2,
                        }
                        allDeviceModelIDArr.push({
                            'name': item2.deviceName,
                            'modelId': item2.modelId
                        })
                    })
                })
                this.allDeviceModelID = allDeviceModelIDArr
                // console.log(this.allDeviceModelID)
                // console.log(this.list)
            }).catch(err => {
                console.log(err)
            })
        },
        methods: {
            handleNodeClick(data, node, elem) {
                // console.log(this.$refs.deviceTree.getCurrentKey(data.id))
                // console.log(data, node, elem)
                if (node.childNodes.length == 0) {
                    // console.log(data.id )
                    this.$refs.deviceTree.setCurrentKey(data.id)
                    // console.log(data.deviceInfo);
                    // console.log(JSON.parse(data.deviceInfo.deviceDetails))
                    // // this.showDetail = true
                    this.currentDevice.modelId = data.deviceInfo.modelId
                    this.currentDevice.deviceImg = data.deviceInfo.deviceImg
                    this.currentDevice.deviceName = data.deviceInfo.deviceName
                    this.currentDevice.deviceClassName = data.deviceInfo.deviceClassName
                    this.currentDevice.deviceModelName = data.deviceInfo.deviceModelName
                    this.currentDevice.deviceDetails = JSON.parse(data.deviceInfo.deviceDetails)
                    this.$emit('showDevice', this.allDeviceModelID, this.currentDevice.modelId)
                }
            },
            handleClickPosition(node, data) {
                // console.log(node, data)
            },
        },
    };
</script>

<style lang="less" scoped>
    .button {
        .w(336);
        .h(56);
        background-image: url('../../assets/img/设备列表.png');
        background-size: 100% 100%;
        cursor: pointer;
        color: rgba(230, 243, 253, 0.7);
        font-size: 18rem;
        position: fixed;
        bottom: 1180/108vh;
        right: 4560/192vw;
        padding: 0 250/192vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        img {
            .w(7);
            .h(12);
        }
    }

    .list {
        .w(336);
        .h(300);
        background-image: url('../../assets/img/展开.png');
        background-size: 100% 100%;
        color: rgba(255, 255, 255, 0.7);
        font-size: 16rem;
        position: fixed;
        bottom: 1180/108vh;
        right: 4560/192vw;
        padding: 40/108vh 180/192vw;
        overflow: hidden;
        // display: flex;
        // flex-direction: column;
        // justify-content: flex-start;
        // align-items: center;


        .title {
            width: 100%;
            .h(50);
            font-size: 18rem;
            padding: 0 140/192vw 0 70/192vw;
            cursor: pointer;
            border-bottom: 1px solid rgba(255, 255, 255, 0.15);
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .content {
            width: 100%;
            .h(235);
            overflow-y: auto;

            .el-tree {
                background: none;
            }

        }
    }

    .detail {
        .w(382);
        .h(448);
        position: fixed;
        top: 3310/108vh;
        left: 5220/192vw;
        background-image: url(../../assets/img/设备参数.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .head {
            width: 100%;
            .h(134);
            margin-top: 200/108vh;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 200/108vh 170/192vw 150/108vh;

            .pic {
                .w(96);
                .h(96);
                background: rgba(13, 148, 255, 0.2);
            }

            .data {
                width: 60%;
                .h(96);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                font-size: 14rem;
                font-family: Source Han Sans CN;
                color: #60A9E2;
            }

            .close {
                .w(17);
                .h(17);
                cursor: pointer;
            }
        }

        .body {
            width: 100%;
            .h(275);
            overflow-y: auto;
        }
    }

    .content::-webkit-scrollbar {
        width: 50/192vw;
        height: 1px;
    }

    .content::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    .body::-webkit-scrollbar {
        display: none;
        // width: 50/192vw;
        // height: 1px;
    }

    .body::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    .list-enter,
    .list-leave-to {
        .h(56)
    }

    .list-enter-active,
    .list-leave-active {
        transition: height .5s
    }
</style>